const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  create ({ state, commit, rootState }, params) {
    return rootState.axios.post('/coin/v1frontend/lucky-draw-ourself/create', params)
  },
  searchWinners ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coin/v1frontend/lucky-draw-ourself/search-winners', { params })
  },
  prepare ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coin/v1frontend/lucky-draw-ourself/prepare', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
